import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockBehaviorDataType } from "../../../../../enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockBehaviorSelectionType } from "../../../../../enums/SDKDocsBlockBehaviorSelectionType";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.figma-components";
const name = "Figma component";
const icon = "https://cdn-assets.supernova.io/blocks/icons/figma-component.svg";
const descriptionShort = "Display components and variants from Figma";
const keywords = ["variants", "properties"];
const descriptionFull = "Display components and variants from Figma";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/token/tokens/general-84NRgxGl#section-token-group-09";
/**
 * 2. Block properties
 */
const properties = {
    figmaComponent: b.figmaComponentProperty({
        id: "figmaComponent",
        name: "Figma component",
        options: {
            renderLayoutAs: "Grid",
        },
        variants: {
            canvas: {
                renderLayoutAs: "Canvas",
            },
        },
    }),
};
/**
 * 3. Block variants
 */
const variants = [
    b.variantUsingDefaultLayout({
        id: "grid",
        name: "Grid",
        description: "Components or variants will be rendered individually in a grid layout",
        image: "https://cdn-assets.supernova.io/blocks/variants/figma-component-grid.svg",
        properties: [properties.figmaComponent],
        maxColumns: 4,
    }),
    b.variantUsingDefaultLayout({
        id: "canvas",
        name: "Canvas",
        description: "Components or variants will be rendered on a single canvas",
        image: "https://cdn-assets.supernova.io/blocks/variants/figma-component-canvas.svg",
        properties: [properties.figmaComponent],
        maxColumns: 4,
    }),
];
/**
 * 4. Block item
 */
const blockItem = b.multiVariantItem({
    properties: [properties.figmaComponent],
    variants,
});
/**
 * 5. Block definition
 */
const block = b.dataBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.figma,
    description: descriptionShort,
    searchKeywords: keywords,
    dataType: DocsBlockBehaviorDataType.figmaComponent,
    selectionType: DocsBlockBehaviorSelectionType.entity,
    item: blockItem,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as FigmaComponents };
